module.exports = __webpack_public_path__ + "static/alpine-img-7bd963c83bfb318f97df8feb62e1ecf8.png";